import qs from 'query-string';
import api from 'api';
import { API_SCORECARD_OWN } from 'constants/api';
import { ScorecardListItem } from 'store/interfaces';

export const OWN_SCORECARDS_LIMIT = 100;

export default function fetchOwnScorecards(): Promise<ScorecardListItem[]> {
  const url = `${API_SCORECARD_OWN}?${qs.stringify({
    limit: OWN_SCORECARDS_LIMIT,
  })}`;

  return api.axios
    .get<{ list: ScorecardListItem[] }>(url)
    .then((res) => res.data?.list ?? [])
    .catch(() => []);
}
